(function ($) {
  $(document).ready(function () {
    stickyHeader();

    $(window).scroll(function () {
      stickyHeader();
    });

    $("body").addClass("js");

    if ($("a.inline-modal").length) {
      $(".inline-modal").modaal();
    }

    // Initialize testimonials slider
    $(".testimonials__slider").slick({
      autoplay: false,
      speed: 300,
      infinite: true,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 1080,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
      ],
    });

    // Initialize related resources slider
    $(".related-resources__slider").slick({
      autoplay: false,
      speed: 1000,
      infinite: true,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 1080,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
      ],
    });

    $("#qualify-options").change(function () {
      var inputVal = $(this).val();
      var optionText = $(".qualify-description-" + inputVal);
      var optionLink = $(".qualify-link-" + inputVal);
      $(".qualify-description").hide();
      $(".qualify-link").hide();
      $(optionText).show();
      $(optionLink).show();
    });
  });

  // Sticky header
  var stickyHeaderTop = $(".js-header").offset().top;
  var stickyHeader = function () {
    var scrollTop = $(window).scrollTop();

    if (scrollTop > stickyHeaderTop) {
      $(".js-header").addClass("sticky");
    } else {
      $(".js-header").removeClass("sticky");
    }
  };
})(jQuery);
